import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Announcement } from 'src/app/core/models/announcement.model';
import { ANNOUNCEMENT_STATUS_TYPES } from 'src/app/core/models/enum.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { AnnouncementService } from 'src/app/core/services/announcement.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { VolunteerRoleService } from 'src/app/core/services/volunteer-role.service';

@Component({
  selector: 'app-upsert-announcement',
  templateUrl: './upsert-announcement.component.html',
  styleUrls: ['./upsert-announcement.component.scss']
})
export class UpsertAnnouncementComponent implements OnInit {
  announcement = new Announcement();
  addAnnouncementForm: FormGroup;
  roles = [];
  status_types = ANNOUNCEMENT_STATUS_TYPES;

  constructor(private alertService: AlertService,
    private loadingService: LoadingService,
    private announcementService: AnnouncementService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private volunteerRoleService: VolunteerRoleService) { }

  ngOnInit(): void {
    this.getVolunteerTypes();
    this.addAnnouncementForm = this.formBuilder.group({
      title: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      description: new FormControl('', [
        Validators.required
      ]),
      availableAllUser: new FormControl(''),
      roleIds: new FormControl(''),
      status: new FormControl(null, [
        Validators.required
      ]),
      validUntil: new FormControl(null, [
        Validators.required
      ])
    });

    if (this.route.snapshot.params.id) {
      this.announcementService.getById(this.route.snapshot.params.id).subscribe(response => {
        if (response.success) {
          this.announcement = response;
          console.log(response);
          this.addAnnouncementForm.controls['title'].setValue(this.announcement.title);
          this.addAnnouncementForm.controls['description'].setValue(this.announcement.description);
          this.addAnnouncementForm.controls['availableAllUser'].setValue(this.announcement.availableAllUser);
          this.addAnnouncementForm.controls['status'].setValue(this.announcement.status);
          this.addAnnouncementForm.controls['roleIds'].setValue(this.announcement.roleIds);
          this.addAnnouncementForm.controls['validUntil'].setValue(this.announcement.validUntil);
        }
      })
    }
  }

  getVolunteerTypes() {
    this.volunteerRoleService.getSingleRoles().subscribe(response => {
      if (response.success){
        console.log(response)
        this.roles = response.roles; 
      }
    })
  }

  save() {
    if (this.addAnnouncementForm.invalid) {
      this.alertService.alert('Hata', 'Lütfen formdaki alanları eksiksiz tamamlayınız!', 'error')
      return;
    }
    if (this.addAnnouncementForm.valid) {
      this.loadingService.setLoading(true);
      let data = Object.assign({}, this.addAnnouncementForm.value);

      this.announcement.title = data.title;
      this.announcement.description = data.description;
      this.announcement.availableAllUser = data.availableAllUser;
      this.announcement.roleIds = data.roleIds;
      this.announcement.status = data.status;
      this.announcement.validUntil = data.validUntil;

      console.log(this.announcement);

      if (this.announcement.id) {
        this.announcementService.updateAnnouncement(this.announcement).subscribe(response => {
          if (response.success) {
            this.alertService.alert('Başarılı!', 'Duyuru güncellendi!', 'success')
            this.router.navigate(['/announcement-list']);
          }
          this.loadingService.setLoading(false);
        }, (error) => {
          this.loadingService.setLoading(false);
          this.alertService.alert('Hata!', error.error.Message, 'error');
        })
      }
      else {
        console.log(this.announcement);
        this.announcementService.createAnnouncement(this.announcement).subscribe(response => {
          if (response.success) {
            this.alertService.alert('Başarılı!', 'Duyuru eklendi!', 'success')
            this.router.navigate(['/announcement-list']);
          }
          this.loadingService.setLoading(false);
        }, (error) => {
          this.loadingService.setLoading(false);
          this.alertService.alert('Hata!', error.error.Message, 'error');
        })
      }



    }
  }

  get f() {
    return this.addAnnouncementForm.controls;
  }

}
